/* global window */
import { useCallback, useEffect, useState } from 'react';
import cookie from '../../../helpers/cookies';
import { calculateMaxAgeBeforeMidNight, generateSessionId } from 'Helpers/userSession';
import { COOKIES } from 'Constants/constants';

// eslint-disable-next-line no-magic-numbers
const DAYS_IN_MILLISECONDS = 24 * 60 * 60 * 1000;

export const useSessionManager = () => {
    const cookieConfig = COOKIES.SESSION_ID;
    const sessionCookieName = cookieConfig?.name;
    const sessionCookieMaxAge = cookieConfig?.maxAge;

    const sessionCheckInterval = calculateMaxAgeBeforeMidNight(cookieConfig?.sessionCheckInterval);

    const [sessionId, setSessionId] = useState(null);

    const getMaxAge = useCallback(() => {
        return calculateMaxAgeBeforeMidNight(sessionCookieMaxAge) / DAYS_IN_MILLISECONDS;
    }, [sessionCookieMaxAge]);

    useEffect(() => {
        const updateSessionExpiration = () => {
            const existingSession = cookie.readCookie(sessionCookieName);

            if (existingSession) {
                cookie.createCookie(sessionCookieName, existingSession, getMaxAge());
            }
        };

        const resetTimer = () => {
            updateSessionExpiration();
        };

        window.addEventListener('mousemove', resetTimer);
        window.addEventListener('keydown', resetTimer);
        window.addEventListener('scroll', resetTimer);
        window.addEventListener('touchmove', resetTimer);

        const checkSessionExpiry = setInterval(() => {
            const existingSession = cookie.readCookie(sessionCookieName);

            if (!existingSession) {
                const newSession = generateSessionId();

                cookie.createCookie(sessionCookieName, newSession, getMaxAge());
                setSessionId(newSession);
            }
        }, sessionCheckInterval);

        return () => {
            window.removeEventListener('mousemove', resetTimer);
            window.removeEventListener('keydown', resetTimer);
            window.removeEventListener('scroll', resetTimer);
            window.removeEventListener('touchmove', resetTimer);
            clearInterval(checkSessionExpiry);
        };
    }, [sessionCookieName, sessionCheckInterval, getMaxAge]);

    return sessionId;
};
